export default __webpack_public_path__ + "static/media/Mask_Group_4@2x.1aceba19.png";